import {IconButton, Tooltip} from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import EmailIcon from '@material-ui/icons/Email'
import FileCopyIcon from '@material-ui/icons/FileCopy'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import PersonAddIcon from '@material-ui/icons/PersonAdd'
// import useStyles from './ReportsIndexTablestyles'
import ReportsMenu from 'modules/reports/components/Menu'
import ReportsMenuItem from 'modules/reports/components/Menu/Item'
import {useReportsTableRowContext} from 'modules/reports/components/Table/Row/ReportsTableRow.context'
import useCore from 'modules/reports/hooks/core'
import useDialog from 'modules/reports/hooks/dialog'
import useModal from 'modules/reports/hooks/modal'
import ReportsEmailModal from 'modules/reports/modals/Email'
import ReportsUsersModal from 'modules/reports/modals/Users'
import Report from 'modules/reports/models/Report'
import React from 'react'

type Props = {}

function ReportsIndexTableActions(props: Props) {
  // const classes = useStyles()
  const report: Report = useReportsTableRowContext().item
  const modal = useModal()
  const dialog = useDialog()
  const {p, pt} = useCore('reports', 'components', 'IndexTableActions')

  function handleEmail() {
    modal.open(ReportsEmailModal, {report})
  }

  function handleAddUser() {
    modal.open(ReportsUsersModal, {report})
  }

  function handleDuplicate() {
    alert('// TODO duplicate')
  }

  async function handleDelete() {
    const confirmed = await dialog.confirm(pt('confirm-delete', {name: report.name}))
    if (confirmed) alert('// TODO delete')
  }

  return (
    <ReportsMenu
      trigger={({ariaProps, open}) => (
        <Tooltip title={pt('title')}>
          <IconButton
            {...ariaProps}
            aria-label={pt('title')}
            onClick={open}
            data-testid={p('trigger')}
          >
            <MoreVertIcon />
          </IconButton>
        </Tooltip>
      )}
    >
      <ReportsMenuItem onClick={handleEmail} icon={<EmailIcon />} data-testid={p('email')}>
        {pt('email')}
      </ReportsMenuItem>

      <ReportsMenuItem onClick={handleAddUser} icon={<PersonAddIcon />} data-testid={p('add-user')}>
        {pt('add-user')}
      </ReportsMenuItem>

      <ReportsMenuItem
        href={`/reports/${report.id}/edit`}
        icon={<EditIcon />}
        data-testid={p('edit')}
      >
        {pt('edit')}
      </ReportsMenuItem>

      <ReportsMenuItem
        onClick={handleDuplicate}
        icon={<FileCopyIcon />}
        data-testid={p('duplicate')}
      >
        {pt('duplicate')}
      </ReportsMenuItem>

      <ReportsMenuItem
        onClick={handleDelete}
        icon={<DeleteIcon />}
        danger
        data-testid={p('delete')}
      >
        {pt('delete')}
      </ReportsMenuItem>
    </ReportsMenu>
  )
}

export default ReportsIndexTableActions
